<template>
  <div :class="$style['adl-chart-time-series']">
    <adl-chart-time-series
      :data="chartData"
      :domainX="chartProperties.domainX"
      :color="chartProperties.color"
      :legendItems="chartProperties.legendItems"
      :legendKeyType="chartProperties.legendKeyType"
      :height="chartProperties.height"
      :axisLeftWidth="chartProperties.axisLeftWidth"
      :axisRightWidth="chartProperties.axisRightWidth"
      :hideMouseHover="hideMouseHover"
      :tooltipWidth="tooltipWidth"
      :tooltipheight="tooltipheight"
      @setTooltipData="setTooltipData"
    >
      <template v-slot:tooltipText v-if="!hideMouseHover">
        <div
          :class="$style['tooltip-wrapper']"
          v-for="(element, i) in toolTipData"
          :key="i"
        >
          <div :class="i == 0 ? '' : $style['add-margin']">
            {{ element.description }}
          </div>
          <div :class="$style['bold-text']">{{ element.title }}</div>
        </div>
      </template>
    </adl-chart-time-series>
  </div>
</template>
<script>
import AdlChartTimeSeries from "../custom/chart-time-series/ChartTimeSeries.vue";
export default {
  props: {
    chartProperties: {
      type: Object,
    },

    chartData: {
      type: Array,
    },
  },
  data() {
    return {
      toolTipData: [],
      hideMouseHover: true,
      tooltipheight: 80,
      tooltipWidth: 120,
    };
  },
  computed: {},
  components: {
    AdlChartTimeSeries,
  },
  methods: {
    setTooltipData(xaxis) {
      this.hideMouseHover = true;
      this.toolTipData = [];
      let element = this.chartData.filter(
        (sr) =>
          new Date(sr.startYear, sr.startMonth - 1, 1) <= xaxis.id &&
          new Date(sr.endYear, sr.endMonth - 1, 1) >= xaxis.id
      );
      if (element != null && element.length > 0) {
        if (element[0].toolTipData) {
          this.toolTipData = element[0].toolTipData;
        } else {
          this.toolTipData.push(element[0]);
        }
        this.hideMouseHover = false;
      }
    },
  },
};
</script>
<style lang="scss" module>
.adl-chart-time-series {
  .tooltip-wrapper {
    min-width: 60px;
  }
  .add-margin {
    margin-top: 10px;
  }
  .bold-text {
    font-weight: bold;
  }
}
</style>
